import { render, staticRenderFns } from "./IP_RebuttalsTrackingByOriginalAuditor.vue?vue&type=template&id=2bfc4bf9&scoped=true&"
import script from "./IP_RebuttalsTrackingByOriginalAuditor.vue?vue&type=script&lang=js&"
export * from "./IP_RebuttalsTrackingByOriginalAuditor.vue?vue&type=script&lang=js&"
import style0 from "./IP_RebuttalsTrackingByOriginalAuditor.vue?vue&type=style&index=0&id=2bfc4bf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc4bf9",
  null
  
)

export default component.exports